import { render, staticRenderFns } from "./Ordergrab.vue?vue&type=template&id=820869fe&scoped=true"
import script from "./Ordergrab.vue?vue&type=script&lang=js"
export * from "./Ordergrab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "820869fe",
  null
  
)

export default component.exports